import { render, staticRenderFns } from "./viewLists.vue?vue&type=template&id=2afc1ff0&scoped=true&"
import script from "./viewLists.vue?vue&type=script&lang=js&"
export * from "./viewLists.vue?vue&type=script&lang=js&"
import style0 from "./viewLists.vue?vue&type=style&index=0&id=2afc1ff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afc1ff0",
  null
  
)

export default component.exports